module.exports = __webpack_public_path__ + "img/logo白@3x.94986d38.png";